import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy,Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

import { AdminComponentBase, PageSimpleContentComponent } from 'app/layout/content';
import { AuthorizationContext, AuthorizationService, AuthorizedUsersService } from 'app/shared/authentication';
import { ErrorComponent } from 'app/shared/components/error.component';
import { PromptDialogService } from 'app/shared/dialog/prompt-dialog.service';
import { GlobalPermission, PageInfo, UserRoles } from 'app/shared/graph';
import { CopyToClipboardComponent } from 'app/shared/utilities/copy-to-clipboard.component';
import { FromNowPipe } from 'app/shared/utilities/from-now.pipe';

@Component({
    templateUrl: './admin-users-page.component.html',
    styleUrls: ['./admin-users-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageSimpleContentComponent, FormsModule, MatFormField, MatIcon, MatPrefix, MatLabel, MatInput, MatError, MatButton, ErrorComponent, MatTable, MatColumnDef, MatHeaderCell, MatCell, CopyToClipboardComponent, RouterLink, MatHeaderRow, MatRow, MatIconButton, DatePipe, FromNowPipe, MatHeaderCellDef, MatCellDef, MatHeaderRowDef, MatRowDef, MatTooltip]
})
export class AdminUsersPageComponent extends AdminComponentBase implements OnInit, OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly authorizationService = inject(AuthorizationService);
    private readonly authorizedUsersService = inject(AuthorizedUsersService);
    private readonly promptDialogService = inject(PromptDialogService);

    users: UserRoles[] = [];
    pageInfo: PageInfo = { page: 0, pageSize: 5, hasNextPage: false };
    filter?: string;
    authorizationContext: AuthorizationContext;

    @ViewChild(MatPaginator) paginator: MatPaginator;


    ngOnInit() {
        this.registerSubscription(this.authorizationService.authorizationContext().subscribe(authorizationContext => {
            this.authorizationContext = authorizationContext;
        }));
        this.subscribeWithGenericLoadingErrorHandling(this.authorizedUsersService.listUsers(0), result => {
            this.users = result.items || [];
            this.pageInfo = result.pageInfo;
        });
    }

    ngOnDestroy() {
        this.unsubscribeSubscriptions();
    }

    search() {
        this.subscribeWithGenericSavingErrorHandling(this.authorizedUsersService.listUsers(0, this.filter), result => {
            this.users = result.items || [];
            this.pageInfo = result.pageInfo;
        });
    }

    loadPage(page: number) {
        this.subscribeWithGenericSavingErrorHandling(this.authorizedUsersService.listUsers(page, this.filter), result => {
            this.users = result.items || [];
            this.pageInfo = result.pageInfo;
        });
    }

    userRole$(element: any): UserRoles {
        return element as UserRoles;
    }

    canAddUsers() {
        return this.authorizationContext.hasGlobalPermissions(GlobalPermission.ManageAdminUsers);
    }

    openAddUserDialog() {
        this.registerSubscription(this.promptDialogService.prompt('Add user', undefined, { fieldLabel: 'Email' }).subscribe((email) => {
            this.subscribeWithGenericSavingErrorHandling(this.authorizedUsersService.grantUserRole({
                email: email
            }), () => {
                this.router.navigate([email], { relativeTo: this.route });
            });
        }));
    }
}
